import PresentacionDraftView from './views/PresentacionDraftView.vue'

export default [
  {
    path: '/draft',
    name: 'draft',
    component: PresentacionDraftView
  }
]
